import { useEffect, useState } from "react";
import "./Auth.css";

function RecuperarPassword() {
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [show, setShow] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setToken(params.get("token"));
  }, []);

  const cambiar = async () => {
    if (password !== confirmar) {
      alert("Las contraseñas no coinciden");
      return;
    }

    if (password.length < 6) {
      alert("Mínimo 6 caracteres");
      return;
    }

    try {
      const res = await fetch(
        "https://sindicato.sintrasecsalud.com/api/index.php?modulo=auth&accion=cambiarPassword",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, password }),
        },
      );

      const data = await res.json();

      if (data.success) {
        alert("Contraseña actualizada correctamente");
        window.location.href = "/";
      } else {
        alert(data.message);
      }
    } catch (error) {
      alert("Error de conexión con el servidor");
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h4>Nueva contraseña</h4>

        <div className="password-group mb-3">
          <input
            type={show ? "text" : "password"}
            placeholder="Nueva contraseña"
            className="form-control auth-input"
            onChange={(e) => setPassword(e.target.value)}
          />
          <span onClick={() => setShow(!show)}>👁️</span>
        </div>

        <input
          type="password"
          placeholder="Confirmar contraseña"
          className="form-control auth-input mb-3"
          onChange={(e) => setConfirmar(e.target.value)}
        />

        <button onClick={cambiar} className="auth-btn">
          Cambiar contraseña
        </button>
      </div>
    </div>
  );
}

export default RecuperarPassword;
